const WIDTHS = [160, 320, 640, 960, 1280];
const VERSIONED_IMAGE = /\/store\/media\/.+\/products\/\d+\/(?:variants\/\d+|base)\/[^/]+-\d{8}T\d{6}\.\d{9}\.(?:jpe?g|png)$/i;

// Only Store's immutable product URLs support these resize parameters.
export function responsiveMedia(url, sizes = "320px") {
    if (!url || (!/^https?:\/\//i.test(url) && !url.startsWith("/"))) {
        return { src: url };
    }
    const parsed = new URL(url, window.location.origin);
    if (!VERSIONED_IMAGE.test(parsed.pathname) || !parsed.searchParams.has("organization_id")) {
        return { src: url };
    }
    const resized = (width) => {
        const next = new URL(parsed);
        next.searchParams.set("width", String(width));
        next.searchParams.set("format", "webp");
        return next.toString();
    };
    return {
        src: resized(640),
        srcSet: WIDTHS.map((width) => `${resized(width)} ${width}w`).join(", "),
        sizes,
    };
}
